import SocialIcons from "./SocialIcons";
import { Flex } from "./styled/Flex.styled";
import { StyledFooter } from "./styled/Footer.styled";
import { FaWhatsapp } from "react-icons/fa";

const Footer = () => {
  return (
    <StyledFooter>
      <img src="./images/logo-sardana-group-putih.png" alt="" />

      <Flex>
        <ul>
          <li>
            Dapatkan penawaran dan promo terbaik dari Mitsubishi New Xpander.
            Ayo segera kontak kami di nomor dibawah ini.
          </li>
          <li>
            <a
              target="_blank"
              href="https://wa.me/+628116541800?text=[NXP]Halo Sardana berlian. Saya tertarik dengan penawaran dan promo dari Mitsubishi new Xpander."
            >
              <FaWhatsapp style={{ fontSize: 20 }} /> 0811-654-1800
            </a>
          </li>
        </ul>
        <ul>
          <li>
            <a
              target="_blank"
              href="https://hargamitsubishimedan.id/product/new-xpander/"
            >
              New Xpander
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://hargamitsubishimedan.id/product/new-xpander-cross/"
            >
              New Xpander Cross
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://hargamitsubishimedan.id/product/xpander/"
            >
              Pajero Sport
            </a>
          </li>
        </ul>

        <ul>
          <li>
            <a
              target="_blank"
              href="https://hargamitsubishimedan.id/product/eclipse-cross/"
            >
              Eclipse Cross
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://hargamitsubishimedan.id/product/triton/"
            >
              Triton
            </a>
          </li>
          <li>
            <a
              target="_blank"
              href="https://hargamitsubishimedan.id/product/l300/"
            >
              L300
            </a>
          </li>
        </ul>

        <SocialIcons />
      </Flex>

      <p>&copy; 2021 PT. Sardana IndahBerlian Motor. All rights reserved</p>
    </StyledFooter>
  );
};

export default Footer;
